if (!customElements.get('oh-outfit-look')) {
  customElements.define('oh-outfit-look', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const color = event.target.closest('[data-look-color]');
        if (color && this.contains(color)) {
          event.preventDefault(); event.stopPropagation();
          const item = color.closest('.oh-look__item');
          const template = [...item.querySelectorAll('template[data-look-card]')].find(t=>t.dataset.lookCard===color.dataset.lookColor);
          if (!template) return;
          const card = template.content.querySelector('product-card').cloneNode(true);
          item.querySelector('product-card').replaceWith(card);
          item.querySelectorAll('[data-look-color]').forEach(dot=>{
            const active=dot===color;
            dot.classList.toggle('oh-dot--active',active);
            if(active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');
          });
          const slot=item.querySelector('.oh-look__wishlist');
          slot.replaceChildren(); slot.dataset.productUrl=color.getAttribute('href'); delete slot.dataset.ohMounted;
          document.dispatchEvent(new CustomEvent('oh:cards-updated'));
          if(typeof card.init==='function')card.init();
          return;
        }
        const button = event.target.closest('.oh-qa__open, .oh-qa__size');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const panel = button.closest('.oh-qa');
        if (button.dataset.id) {
          this.addItem(button.dataset.id, button, panel);
        } else {
          this.querySelectorAll('.oh-qa.is-open').forEach(other => { if (other !== panel) other.classList.remove('is-open'); });
          panel.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(panel.classList.contains('is-open')));
        }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.querySelectorAll('.oh-qa.is-open').forEach(panel => {
            panel.classList.remove('is-open');
            panel.querySelector('.oh-qa__open').setAttribute('aria-expanded', 'false');
          });
        }
      });
      this.querySelectorAll('.oh-qa__msg').forEach(message => { message.setAttribute('role', 'status'); message.setAttribute('aria-live', 'polite'); });
    }
    async addItem(id, button, panel) {
      if (button.disabled || panel.classList.contains('is-busy')) return;
      const drawer = document.querySelector('cart-drawer');
      const root = window.Shopify?.routes?.root || '/';
      const payload = {items:[{id:Number(id), quantity:1}]};
      if (drawer?.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(section => section.section);
        payload.sections_url = location.pathname;
      }
      const message = panel.querySelector('.oh-qa__msg');
      panel.classList.add('is-busy');
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Nie udało się dodać produktu. Spróbuj ponownie.');
        panel.classList.remove('is-open');
        panel.classList.add('is-added');
        message.textContent = 'Dodano do koszyka';
        if (drawer?.renderContents && result.sections) drawer.renderContents(result);
        else location.href = root + 'cart';
        setTimeout(() => panel.classList.remove('is-added'), 1800);
      } catch (error) {
        message.textContent = error.message || 'Nie udało się dodać produktu. Spróbuj ponownie.';
        panel.classList.add('has-msg');
      } finally {
        panel.classList.remove('is-busy');
      }
    }
  });
}